<div
  class="fixed bottom-0 left-0 flex gap-2 w-full text-[10px] text-[#999999] p-2 border-t border-[#D2D2D2] bg-[#FAFAFA] justify-center md:gap-8 md:text-[8px] md:border-none">
  <span class="md:hover:text-[#F0811A] md:hover:cursor-pointer" routerLink="/imprint">Impressum</span>
  <span class="md:hover:text-[#F0811A] md:hover:cursor-pointer" routerLink="/privacy">Datenschutz</span>
  <span class="md:hover:text-[#F0811A] md:hover:cursor-pointer" routerLink="/conditions">Nutzungsbedingungen</span>
  <span class="md:hover:text-[#F0811A] md:hover:cursor-pointer" routerLink="/fundamentals">Grundsätze</span>
  <span class="md:hover:text-[#F0811A] md:hover:cursor-pointer" routerLink="/agb">AGB</span>
  <span class="hidden md:flex">|</span>
  <span class="hidden md:flex md:hover:text-[#F0811A] md:hover:cursor-pointer" routerLink="/faq">FAQ</span>
</div>
